// extracted by mini-css-extract-plugin
export var actionText = "_rw-4";
export var container = "_rw-0";
export var leftSection = "_rw-1";
export var rightSection = "_rw-2";
export var settingsButton = "_rw-6";
export var settingsIcon = "_rw-7";
export var shortcut = "_rw-5";
export var shortcutGroup = "_rw-3";